import React from "react";
import {SvgIcon, SvgIconProps} from "@material-ui/core"


const GreenCheckIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg version="1.1" id="Layer_1" x="0px" y="0px"
                 viewBox="0 0 512 512">
                <g id="Group_437" transform="translate(-672 -803)">
                    <path id="Path_25" fill="#31CE55" d="M919.445,1149.921h-0.397c-5.189-0.107-10.11-2.326-13.626-6.144l-96.009-104.285
		c-7.138-7.751-6.642-19.82,1.107-26.96c7.751-7.138,19.82-6.642,26.959,1.108l82.55,89.677l228.821-228.215
		c7.442-7.445,19.51-7.447,26.955-0.005c0.002,0.002,0.003,0.003,0.005,0.005c7.451,7.436,7.462,19.504,0.026,26.955
		c-0.009,0.009-0.017,0.017-0.026,0.026l-242.907,242.259C929.331,1147.906,924.492,1149.912,919.445,1149.921z"/>
                    <path id="Path_26" fill="#31CE55" d="M927.637,1312.053c-139.693-0.161-252.893-113.371-253.043-253.064
		c0.161-139.685,113.358-252.881,253.043-253.043c10.538,0,19.081,8.543,19.081,19.081s-8.543,19.081-19.081,19.081
		c-118.606,0.195-214.707,96.296-214.902,214.903c0.195,118.606,96.296,214.707,214.902,214.903
		c118.635-0.127,214.776-96.268,214.903-214.903c0-10.538,8.543-19.081,19.08-19.081s19.081,8.543,19.081,19.081
		C1180.54,1198.703,1067.33,1311.903,927.637,1312.053z"/>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
            </svg>
        </SvgIcon>
    )
};

export default GreenCheckIcon;